module.exports = __webpack_public_path__ + "img/group-chat.fe095cd3.png";